import { useCallback, useState } from 'react';
import { useDisclosure } from '~/app/_hooks/use-disclosure';
import type { FollowListType } from './types';
import { useFetchFollowList } from './use-fetch-follow-list';

export const useLocalHooks = (userId: string) => {
  const [followListType, setFollowListType] =
    useState<FollowListType>('follower');

  const followListingsModalDisclosure = useDisclosure();

  const handleFollowButtonClick = useCallback(
    (followType: FollowListType) => {
      setFollowListType(followType);
      followListingsModalDisclosure.onOpen();
    },
    [followListingsModalDisclosure]
  );

  const closeListingsModal = useCallback(() => {
    followListingsModalDisclosure.onClose();
  }, [followListingsModalDisclosure]);

  const changeList = useCallback((type: FollowListType) => {
    setFollowListType(type);
  }, []);

  const {
    followData,
    isLoading,
    error,
    isEmpty,
    isLoadingFirstPage,
    paginationRef,
  } = useFetchFollowList(userId, followListType);

  return {
    followList: followData,
    isLoading,
    error,
    isEmpty,
    isLoadingFirstPage,
    followListType,
    followListingsModalDisclosure,
    handleFollowButtonClick,
    closeListingsModal,
    paginationRef,
    changeList,
  };
};
